//Estado por default de Alertas Tempranas.
const defaultState = {
  listaAlertas: [],
  totalAlertas: 0,
  loadedAlertas: false,
};

//Componente Redux para cambiar el estado de Alertas Tempranas.
export const alertReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "FETCH_LAST_ALERTS":
      return {
        ...state,
        listaAlertas: action.payload.registros,
        totalAlertas: action.payload.total,
        loadedAlertas: true,
      };
    case "CLEAR_LAST_ALERTS":
      return {
        ...state,
        loadedAlertas: false,
      };

    default:
      return { ...state };
  }
};
